"use strict";

exports.__esModule = true;
exports.OptionWrapper = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// This is a private, not intended for use except by the Select
// component for wrapping Options
// TODO refactor me I'm hideous!
var OptionWrapper = function OptionWrapper(props) {
  var onMouseOver = props.onMouseOver,
      onClick = props.onClick,
      onOptionWrapperRef = props.onOptionWrapperRef,
      selectedKey = props.selectedKey,
      highlightedKey = props.highlightedKey,
      children = props.children,
      optionKey = props.optionKey,
      label = props.label,
      value = props.value,
      disabled = props.disabled,
      highlightedRef = props.highlightedRef,
      others = _objectWithoutProperties(props, ["onMouseOver", "onClick", "onOptionWrapperRef", "selectedKey", "highlightedKey", "children", "optionKey", "label", "value", "disabled", "highlightedRef"]);

  var highlighted = optionKey === highlightedKey;
  var selected = optionKey === selectedKey;
  var ariaLabel = label || value;
  return _react2.default.createElement(
    "li",
    _extends({
      id: "react-a11y-option-" + optionKey,
      className: "ReactA11ySelect__ul__li",
      tabIndex: highlighted ? "0" : "-1",
      role: "menuitemradio",
      "aria-checked": selected ? true : undefined,
      "aria-disabled": disabled ? true : undefined,
      "aria-label": ariaLabel,
      ref: function ref(e) {
        return onOptionWrapperRef(e);
      },
      disabled: disabled ? true : undefined,
      onMouseOver: disabled ? undefined : onMouseOver,
      onClick: disabled ? undefined : onClick
    }, others),
    selected && _react2.default.createElement("span", { className: "ReactA11ySelect__ul__li__selected-indicator", "aria-hidden": "true" }),
    children
  );
};
exports.OptionWrapper = OptionWrapper;
exports.default = OptionWrapper;